import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import VueMoment from 'vue-moment'
import VueFormGenerator from 'vue-form-generator'
import Multiselect from 'vue-multiselect'
import VueMq from 'vue-mq'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/simple.css'

import Spinner from 'vue-spinner-component/src/Spinner'
import moment from 'moment-timezone'

import i18n from './locales'

// import HttpPlugin from '@/plugins/http'


// Ant design
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

// UGLY solution for implementing Http/Api
import Http from '@/http/http-common'
Vue.prototype.$http = Http

import resourceApi from '@/helpers/resourceApi'

Vue.prototype.$resource = resourceApi

Vue.use(i18n)
Vue.use(Antd)

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(VueMoment, { moment })
Vue.use(VueFormGenerator)

Vue.use(Snotify, {
    toast: {
        position: SnotifyPosition.leftBottom,
        oneAtTime: true,
    },
})

Vue.component('spinner', Spinner)

Vue.component('multiselect', Multiselect)
Vue.component('Multiselect', Multiselect)
Vue.use(VueMq, {
    breakpoints: {
        sm: 450,
        md: 1250,
        lg: Infinity,
    },
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>',
    created() {
        this.$store
            .dispatch('auth/initialize')
            .then(() => {
                // console.log('Auth check success!', res)
                // Get available companies and cache them in store
                this.$store.dispatch('companies/getCompanies')
            })
            .catch(() => {
                // console.log('Something happened during logon-check!', err)
            })
    },
    methods: {},
    components: {
        App,
    },
    filters: {
        json: value => {
            return JSON.stringify(value, null, 2)
        },
    },
})
